import React, { useMemo } from 'react';
import { Col, Row } from 'tea-component';
import LineChart from '../ChartComponent/LineChart';
import { useIntl } from 'umi';
import { sentimentFormat } from '@/pages/opinion/utils/value';

export default function GameStoreBarChart({
  xAxisList,
  commonParams,
  loading,
  selectedChartData,
  lifetimeChartData,
}: any) {
  const renderList = useMemo(() => {
    return [
      {
        title: 'Selected User Score',
        data: selectedChartData || [],
      },
      {
        title: 'Lifetime User Score',
        data: lifetimeChartData || [],
      },
    ];
  }, [selectedChartData, lifetimeChartData]);
  const { formatMessage } = useIntl();
  return (
    <Row>
      {renderList.map(({ data, title }) => (
        <Col span={12} key={title}>
          <LineChart
            height={270}
            xAxisList={xAxisList}
            data={data}
            title={title}
            leftTitle={formatMessage({ id: title })}
            hasShare={false}
            loading={loading}
            filter={commonParams}
            formatValue={sentimentFormat}
          />
        </Col>
      ))}
    </Row>
  );
}
